import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Grid, Paper, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import actions from 'shared/actions';
import styles from 'shared/styles';
import Username from './ForgotPassword/Username';
import ResetPasswordButton from './ForgotPassword/ResetPasswordButton';

export function ForgotPasswordImpl({ onLoad }) {
  React.useEffect(onLoad, []);
  const [username, setUsername] = React.useState('');
  return (
    <div style={styles.mainBackground}>
      <Paper style={{
        padding: '25px',
        width: '300px',
        borderRadius: '0px',
      }}
      >
        <Grid container spacing={3} alignContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h6">
              Reset your password
            </Typography>
            <Typography>
              Tell us the username associated with your PricePoint account,
              and we’ll send you an email with a link to reset your password.
            </Typography>
          </Grid>
          <Username value={username} setValue={setUsername} />
          <ResetPasswordButton username={username} />
          <Grid item xs={12}>
            <Typography>
              <Link style={styles.link} to="/">Log in</Link>
            </Typography>
          </Grid>
        </Grid>

      </Paper>
    </div>
  );
}

ForgotPasswordImpl.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

ForgotPasswordImpl.defaultProps = {
};

const mapDispatchToProps = {
  onLoad: actions.staging.onLoadShared,
};

export default connect(null, mapDispatchToProps)(ForgotPasswordImpl);
